import { render, staticRenderFns } from "./dpCommerce.vue?vue&type=template&id=cce68838&scoped=true"
import script from "./dpCommerce.vue?vue&type=script&lang=js"
export * from "./dpCommerce.vue?vue&type=script&lang=js"
import style0 from "./dpCommerce.vue?vue&type=style&index=0&id=cce68838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce68838",
  null
  
)

export default component.exports